<template>
  <div :class="['protocol-container', isMobile ? 'mobile' : '', isMinip ? 'minip' : '']">
    <div class="protocol">
      <p class="title" id="div1">元创岛-隐私政策</p>
      <div class="container">
        <div class="update-data">
          <p class="time compact">更新日期：2026年4月28日</p>
          <p class="time compact">生效日期：2026年4月28日</p>
        </div>

        <p>
          元创岛非常重视你的个人信息和隐私保护。你在使用<b>元创岛 App、"元创岛"小程序</b>及其他相关产品与服务时，我们将按照法律法规的规定，遵循<b>合法、正当、必要和诚信原则</b>处理你的个人信息，并采取相应的安全保护措施，尽力保护你的个人信息安全可控。
        </p>
        <p>
          元创岛 App 和"元创岛"小程序由<b>北京小问智能科技有限公司</b>（注册地址：北京市海淀区高梁桥斜街42号院1号楼7层1-729）开发。<b>上海墨百意信息科技有限公司</b>（注册地址：上海市徐汇区丰谷路315弄24号2层2015室，以下简称"我们"）通过元创岛 App 和"元创岛"小程序向你提供产品及服务。
        </p>
        <p>
          在你使用元创岛前，请你仔细阅读并充分理解本隐私政策，特别是与你的个人信息权益、敏感个人信息处理、系统权限调用、第三方共享、账号注销、未成年人保护等相关的内容。如你不同意本隐私政策的任何内容，你应立即停止使用元创岛及相关服务。
        </p>
        <p>
          当你使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现业务功能或根据法律法规要求所必需的必要信息，你均可以拒绝提供，且不影响其他功能或服务。我们将在本隐私政策中逐项说明所要收集的信息。
        </p>
        <p>
          相册、媒体、存储、通知、定位、电话状态、悬浮窗等权限<b>均不会默认开启，</b>只有在你使用特定功能、经过你的授权或满足法律法规规定的条件时，才会为实现特定功能或服务而使用。你也可以通过<b>设备系统设置撤回授权</b>。特别需要指出的是，即使经过你的授权，我们获得了相关权限，也<b>不会</b>在相关功能或服务<b>不需要时收集与你当前使用场景无关的信息。</b>
        </p>

        <p>本隐私政策将帮助你了解以下内容：</p>
        <p class="compact flex"><span>1.</span><span><b>我们如何收集和使用个人信息</b></span></p>
        <p class="compact flex"><span>2.</span><span><b>我们如何使用 Cookie 和同类技术</b></span></p>
        <p class="compact flex"><span>3.</span><span><b>数据使用过程中涉及的合作方、转移、公开个人信息</b></span></p>
        <p class="compact flex"><span>4.</span><span><b>我们如何存储个人信息</b></span></p>
        <p class="compact flex"><span>5.</span><span><b>我们如何保护个人信息的安全</b></span></p>
        <p class="compact flex"><span>6.</span><span><b>行使你的个人信息权利</b></span></p>
        <p class="compact flex"><span>7.</span><span><b>未成年人条款</b></span></p>
        <p class="compact flex"><span>8.</span><span><b>隐私政策的修订和通知</b></span></p>
        <p class="compact flex"><span>9.</span><span><b>联系我们</b></span></p>
        <p class="compact flex"><span>10.</span><span><b>相关术语</b></span></p>

        <!-- 第一章 -->
        <p class="title">1. 我们如何收集和使用个人信息</p>

        <p class="title">1.1 基本原则</p>
        <p>
          我们会按照如下方式收集和使用你在使用服务时<b>主动提供的信息</b>，以及通过自动化方式收集你在使用功能或接受服务过程中产生的信息。我们仅会在实现<b>产品功能、履行法定义务、保障交易和账号安全、处理用户反馈、优化服务体验</b>等必要范围内处理你的个人信息。
        </p>
        <p>
          如我们将你的个人信息用于本隐私政策未载明的其他用途，或基于特定目的将收集而来的信息用于其他目的，我们会依法另行向你告知，并在必要时取得你的同意。
        </p>

        <p class="title">1.2 注册、登录与账号管理</p>
        <p>
          当你<b>注册、登录元创岛</b>账号时，我们会收集你的<b>手机号码、短信验证码、账号标识、登录凭证</b>等信息，用于完成账号注册、身份验证、登录校验、账号安全保护及客户支持。
        </p>
        <p>
          当你使用微信账号<b>登录"元创岛"小程序</b>时，我们会根据你的授权<b>收集微信 OpenID、微信账号绑定的手机号码等信息</b>，用于识别你的账号身份、实现快捷登录和账号绑定。
        </p>
        <p>
          当你使用<b>本机号码一键登录或运营商认证</b>能力时，我们可能会根据相关功能需要处理<b>手机号码掩码、运营商认证结果、网络状态、设备信息</b>等必要信息，用于快速完成身份验证。该能力通常由第三方号码认证服务商提供，具体第三方信息以《第三方信息共享清单》及产品内实际公示为准。
        </p>
        <p>
          当你申请注销账号时，我们会验证你的身份，并处理与你账号注销相关的必要信息，用于完成注销流程、履行法定义务和处理潜在争议。账号注销后，我们将按照法律法规要求及产品规则处理相关数据。
        </p>

        <p class="title">1.3 内容创作、音视频处理与作品管理</p>
        <p>
          当你使用元创岛的<b>音频生成、视频生成、剪辑视频、剪辑音频、图片处理、文本处理、文档处理、作品管理</b>等功能时，我们会处理你<b>主动输入、上传、粘贴、导入、提交</b>或生成的内容，包括<b>文本内容、图片、视频文件、音频文件、文档文件、作品名称、作品内容、生成记录、编辑记录、下载记录、删除记录</b>及相关操作记录，用于向你提供内容生成、素材处理、作品保存、预览、编辑、下载、删除和管理等功能。
        </p>
        <p>
          当你上传文件、图片、音频、视频或文档时，我们会根据功能需要请求你<b>授权相册、媒体</b>、文件访问或存储权限，并处理你<b>主动选择、上传、导入或提交的文件</b>及其相关信息，包括<b>文件内容、文件名称、文件格式、文件大小、上传时间、作品归属</b>及相关操作记录。我们仅会在你主动选择或主动提交相关文件时处理相应内容，<b>不会因你授权相册、媒体、存储或文件访问权限而自动读取与你当前功能无关的其他本地内容</b>。
        </p>
        <p>
          当你使用剪辑视频、剪辑音频或其他创作功能时，为了改进问题、优化产品体验，我们可能会在依法取得必要授权的前提下处理你<b>主动上传的音频、视频、文档等创作数据</b>。我们仅会在实现相关功能、定位问题、优化服务所必需的范围内处理相关内容。
        </p>
        <p>
          如你拒绝授权相册、媒体、存储或文件访问权限，你可能无法使用对应的上传、导入、保存、下载、剪辑或作品管理功能，但不影响你使用元创岛的其他基础功能。
        </p>

        <p class="title">1.4 客服、反馈、公众号与用户支持</p>
        <p>
          当你通过元创岛 App 或"元创岛"小程序联系官方客服、关注官方微信公众号、反馈问题、提交工单或通过其他方式联系我们时，我们可能会处理你的<b>联系方式、账号信息、订单信息、问题描述、沟通记录、截图、录屏、附件、设备信息、App 版本、系统版本、异常日志及与问题相关的必要上下文</b>，用于识别你的身份、定位问题、提供帮助、跟进处理结果和改进服务质量。
        </p>
        <p>
          当你需要保存客服二维码、公众号二维码或相关图片时，我们可能会请求你<b>授权相册、媒体或存储权限，用于将相关二维码或图片保存至本地设备</b>。如你拒绝授权，将无法使用保存至相册或本地的功能，但不影响你使用元创岛的其他功能。
        </p>
        <p>
          客服或技术支持人员仅会在实现支持目的所必要的范围内访问相关信息，并按照内部权限控制和保密要求进行处理。
        </p>

        <p class="title">1.5 会员购买、付费服务、支付、订单与售后服务</p>
        <p>
          当你购买元创岛会员服务或其他付费服务时，我们会处理与你<b>订单、支付和售后相关的信息，包括账号信息、订单编号、下单时间、商品信息、付款金额、支付状态、交易流水号、权益开通状态、退款申请信息及必要的支付凭证信息</b>。
        </p>
        <p>
          具体支付服务通常由<b>第三方支付机构提供</b>，例如微信支付、支付宝、应用商店支付或其他支付服务商。我们<b>不会直接处理你的完整银行卡号、支付密码</b>等由支付机构独立处理的金融信息，但会接收支付结果、订单状态、交易流水号等必要信息，用于确认交易、开通权益、处理售后、退款、对账和履行法定义务。
        </p>

        <p class="title">1.6 关联产品、账号互通与权益服务</p>
        <p>
          由于元创岛产品与魔音工坊产品存在部分账号、权益或内部组件相关能力，为方便你进行相关作品创作和服务使用，你可以使用同一手机号或账号体系登录相关产品，并获得相应的普通用户权益或服务能力。
        </p>
        <p>
          为实现元创岛产品与关联产品和/或服务的账号互通、权益识别、作品服务、客服支持和安全保障，我们可能会与关联产品在必要范围内共同使用你的账号和权益类信息，例如<b>手机号码、用户账号、会员权益状态、登录状态</b>等。前述信息仅会在实现<b>账号识别、权益发放、服务支持和安全保障</b>所必需的范围内处理。
        </p>
        <p>
          如关联产品需要改变个人信息处理目的或扩大处理范围，我们将按照法律法规要求另行告知你，并在必要时征求你的授权同意。
        </p>
        <p>
          当你注销元创岛账号时，你在其他关联产品中的账号是否同步注销，将以相关产品的账号规则、页面提示和你的实际操作为准。我们会按照法律法规要求处理你的注销请求。
        </p>

        <p class="title">1.7 消息通知、提醒与服务通知</p>
        <p>
          为向你发送<b>作品处理结果、账号安全提醒、服务状态通知、会员权益通知、活动通知、客服回复、系统消息</b>或其他与你使用服务相关的提醒，我们可能会请求你授权通知权限，并可能通过<b>系统通知、站内消息、短信、弹窗、推送</b>消息或其他合理方式向你发送相关信息。
        </p>
        <p>
          如你拒绝或关闭通知权限，可能无法及时收到作品处理结果、账号安全提醒、服务通知或活动通知，但不影响你使用元创岛的核心功能。
        </p>
        <p>
          目前，元创岛不会基于你的个人信息向你进行个性化推荐或定向推送。如后续上线相关功能，我们将依法向你告知，并提供关闭方式。
        </p>

        <p class="title">1.8 保障服务运行、安全与体验优化</p>
        <p>
          为保障服务正常运行、优化体验、识别异常状态和防范安全风险，我们可能会处理<b>设备型号、设备名称、设备制造商、操作系统版本</b>、应用版本、SDK 版本、<b>网络状态、网络接入方式、IP 地址、</b>崩溃日志、性能日志、操作日志、服务日志、错误日志、页面访问记录、点击记录、搜索记录及其他必要的技术信息。
        </p>
        <p>
          在移动端 App 环境下，为实现<b>一键登录、账号安全、设备识别、风险控制、统计分析、广告归因、反作弊、支付、分享或第三方 SDK 服务</b>，我们或相关第三方 SDK 可能会在满足法律法规要求、取得必要授权或具备其他合法基础的情况下处理设备标识信息、电话状态信息、Android ID、OAID、IDFA、设备序列号、SIM 卡相关信息、WLAN 接入点信息、已安装应用信息或类似信息。我们会尽量在实现功能所必需的范围内处理该等信息，并通过《第三方信息共享清单》《第三方 SDK 收集个人信息列表》及产品内实际公示说明相关第三方处理情况。
        </p>
        <p>具体系统权限调用情况，请见本政策第 1.9 条。</p>

        <p class="title">1.9 设备权限调用</p>
        <p>
          在你使用元创岛的特定功能时，我们可能会申请或使用系统权限。我们仅会在实现相应功能所必需的范围内申请并使用权限。不同设备系统对权限名称、授权方式和权限展示文案可能存在差异，具体以你设备系统展示为准。你可以在系统设置中管理相关权限，但关闭某些权限后，可能导致对应功能无法正常使用。
        </p>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>权限或能力</th>
                <th>涉及的系统权限/能力</th>
                <th>对应功能或场景</th>
                <th>使用目的</th>
                <th>关闭或拒绝后的影响</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>网络权限</td>
                <td>android.permission.INTERNET</td>
                <td>账号注册、登录、内容生成、音视频处理、作品同步、订单支付、客服反馈、版本更新、活动页面访问等</td>
                <td>用于访问和使用在线服务，完成账号验证、内容生成、作品保存、支付交易、数据同步和服务请求</td>
                <td>无法正常使用需要联网的服务</td>
              </tr>
              <tr>
                <td>网络状态权限</td>
                <td>android.permission.ACCESS_NETWORK_STATE</td>
                <td>网络连接判断、服务可用性判断、异常排查、统计分析等</td>
                <td>用于判断当前网络连接状态，保障服务稳定运行，辅助故障排查和统计分析</td>
                <td>可能影响网络状态判断、服务稳定性或异常排查</td>
              </tr>
              <tr>
                <td>Wi-Fi 状态</td>
                <td>android.permission.ACCESS_WIFI_STATE</td>
                <td>网络状态判断、账号安全、风险控制、统计分析或第三方 SDK 服务</td>
                <td>用于获取当前 Wi-Fi 接入状态及 WLAN 热点信息，辅助网络连接判断、安全风控、统计分析或第三方 SDK 服务</td>
                <td>可能影响网络状态判断、安全风控、统计分析</td>
              </tr>
              <tr>
                <td>网络连接状态变更权限</td>
                <td>android.permission.CHANGE_NETWORK_STATE、android.permission.CHANGE_WIFI_STATE</td>
                <td>网络连接管理、服务稳定性保障、第三方 SDK 基础能力等</td>
                <td>用于在必要场景下支持网络连接状态管理、服务稳定性保障或第三方 SDK 基础能力</td>
                <td>可能影响部分网络连接状态管理、服务稳定性</td>
              </tr>
              <tr>
                <td>手机号码与短信验证码</td>
                <td>手机号码、短信验证码</td>
                <td>手机号注册、登录</td>
                <td>用于创建账号、登录验证、身份识别、账号安全保护和客户支持</td>
                <td>可能无法完成注册、登录或账号验证</td>
              </tr>
              <tr>
                <td>微信授权能力</td>
                <td>微信 OpenID、微信绑定手机号、微信开放平台能力</td>
                <td>微信登录小程序、微信账号绑定、微信分享等</td>
                <td>用于识别微信账号身份、实现快捷登录、账号绑定和分享功能</td>
                <td>可能无法使用微信登录、微信绑定或微信分享功能</td>
              </tr>
              <tr>
                <td>本机号码认证/一键登录能力</td>
                <td>阿里云号码认证服务、中国移动认证 SDK 等号码认证能力</td>
                <td>本机号码一键登录、运营商认证登录</td>
                <td>用于快速完成手机号验证和登录认证</td>
                <td>可能无法使用一键登录，但可使用其他登录方式</td>
              </tr>
              <tr>
                <td>电话状态权限</td>
                <td>android.permission.READ_PHONE_STATE</td>
                <td>一键登录、设备识别、风险控制或第三方 SDK 服务</td>
                <td>用于支持运营商认证、账号安全、设备风险判断和必要统计分析</td>
                <td>可能影响一键登录和账号安全校验，但可使用其他登录方式</td>
              </tr>
              <tr>
                <td>相册、媒体和文件读取权限</td>
                <td>android.permission.READ_MEDIA_VIDEO、android.permission.READ_EXTERNAL_STORAGE</td>
                <td>上传视频、上传音频、上传图片、导入文案文件、导入文档、保存客服二维码、保存公众号二维码、读取本地素材等</td>
                <td>用于读取你主动选择的视频、音频、图片、文档或其他文件，以完成素材上传、作品生成、内容处理和二维码保存</td>
                <td>可能无法上传、读取或导入本地素材，无法保存二维码或相关文件</td>
              </tr>
              <tr>
                <td>存储/文件写入权限</td>
                <td>android.permission.WRITE_EXTERNAL_STORAGE</td>
                <td>保存作品、下载音频、下载视频、下载文件、缓存必要内容、保存二维码等</td>
                <td>用于将作品、文件、二维码或必要缓存内容保存到本地设备</td>
                <td>可能无法保存作品、下载文件或将内容保存至本地</td>
              </tr>
              <tr>
                <td>下载管理权限</td>
                <td>android.permission.ACCESS_DOWNLOAD_MANAGER</td>
                <td>作品下载、文件下载、版本更新包下载等</td>
                <td>用于完成音频、视频、文件、作品或更新包下载</td>
                <td>可能无法完成文件、作品或更新包下载</td>
              </tr>
              <tr>
                <td>剪贴板访问能力</td>
                <td>剪贴板读取或写入能力</td>
                <td>复制、粘贴、链接识别、分享等</td>
                <td>用于在你主动触发相关功能时读取或写入剪贴板中的链接或文本内容</td>
                <td>可能无法使用链接识别、复制粘贴或分享相关功能</td>
              </tr>
              <tr>
                <td>通知权限</td>
                <td>通知权限、系统通知能力</td>
                <td>作品处理结果提醒、账号安全提醒、服务通知、活动通知、客服回复、系统消息等</td>
                <td>用于向你发送与你使用服务相关的提醒和通知</td>
                <td>可能无法及时收到作品处理结果、账号安全提醒、客服回复或活动通知</td>
              </tr>
              <tr>
                <td>定位权限</td>
                <td>android.permission.ACCESS_FINE_LOCATION、android.permission.ACCESS_COARSE_LOCATION</td>
                <td>账号安全、风险控制、统计分析、广告归因、地图能力或第三方 SDK 服务</td>
                <td>用于实现相关位置服务、安全风控、统计分析或第三方 SDK 所需能力。若相关场景仅基于 IP 地址判断大致位置，我们不会因此持续获取你的精准位置</td>
                <td>关闭后不影响核心创作功能</td>
              </tr>
              <tr>
                <td>设备信息与设备标识能力</td>
                <td>com.asus.msa.SupplementaryDID.ACCESS、freemme.permission.msa、设备标识、厂商标识、移动安全联盟标识等</td>
                <td>账号安全、设备识别、反作弊、广告归因、统计分析、崩溃排查、第三方 SDK 服务等</td>
                <td>用于识别设备状态、排查异常问题、保障账号和交易安全、进行统计分析、广告归因和反作弊</td>
                <td>可能影响账号安全校验、异常识别、统计分析、广告归因</td>
              </tr>
              <tr>
                <td>查询应用相关能力</td>
                <td>android.permission.QUERY_ALL_PACKAGES</td>
                <td>判断微信、支付宝、应用商店、分享目标应用或其他相关应用是否安装</td>
                <td>用于支持登录、分享、支付、广告归因、兼容性判断、安全风控或第三方 SDK 服务</td>
                <td>可能影响部分登录、分享、支付、安全校验</td>
              </tr>
              <tr>
                <td>支付相关能力</td>
                <td>com.android.vending.BILLING、支付宝、微信支付、应用内购买等支付能力</td>
                <td>会员购买、订单支付、应用内购买等</td>
                <td>用于完成支付、订单确认、权益开通、退款、对账和售后处理</td>
                <td>可能无法完成购买、支付或权益开通</td>
              </tr>
              <tr>
                <td>安装应用权限</td>
                <td>android.permission.REQUEST_INSTALL_PACKAGES</td>
                <td>App 内版本更新</td>
                <td>用于在你主动触发版本更新时安装更新包</td>
                <td>可能无法通过 App 内完成安装更新</td>
              </tr>
              <tr>
                <td>唤醒锁权限</td>
                <td>android.permission.WAKE_LOCK</td>
                <td>上传、下载、作品生成、音视频处理、消息推送等任务</td>
                <td>用于在必要期间保持任务运行，减少息屏或后台状态下任务中断、延迟的情况</td>
                <td>可能导致相关任务在息屏或后台状态下中断或延迟</td>
              </tr>
              <tr>
                <td>悬浮窗权限</td>
                <td>android.permission.SYSTEM_ALERT_WINDOW</td>
                <td>浮窗提示、辅助操作入口、任务状态展示或第三方 SDK 相关能力</td>
                <td>用于在你主动使用或相关功能需要时，在其他应用上方展示必要的浮窗提示或辅助入口</td>
                <td>可能无法使用悬浮窗提示、辅助入口或相关展示能力</td>
              </tr>
              <tr>
                <td>振动权限</td>
                <td>android.permission.VIBRATE</td>
                <td>通知提醒、交互反馈等</td>
                <td>用于提供振动提醒或操作反馈</td>
                <td>可能无法使用振动提醒或反馈</td>
              </tr>
              <tr>
                <td>状态栏展示相关权限</td>
                <td>android.permission.EXPAND_STATUS_BAR</td>
                <td>系统状态栏展示、通知或页面交互辅助能力</td>
                <td>用于支持状态栏展开、收起或相关系统界面交互能力</td>
                <td>可能影响部分状态栏交互或系统界面展示能力</td>
              </tr>
              <tr>
                <td>系统界面、任务管理或其他辅助权限</td>
                <td>android.permission.REORDER_TASKS</td>
                <td>页面展示、任务切换、系统界面交互、第三方 SDK 基础能力等</td>
                <td>用于保障应用正常运行、页面交互、任务切换、SDK 通信和安全保护</td>
                <td>可能影响部分页面展示、任务切换</td>
              </tr>
              <tr>
                <td>广告、统计或 SDK 内部通信相关能力</td>
                <td>com.mobvoi.yuanchuangdao.openadsdk.permission.TT_PANGOLIN、com.mobvoi.yuanchuangdao.permission.KW_SDK_BROADCAST、com.mobvoi.yuanchuangdao.DYNAMIC_RECEIVER_NOT_EXPORTED_PERMISSION</td>
                <td>广告展示、广告归因、统计分析、SDK 广播等</td>
                <td>用于广告展示、统计分析、应用内部通信和 SDK 基础能力</td>
                <td>可能影响广告展示、广告归因和广告推送的效果</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="title">1.10 敏感个人信息</p>
        <p>
          部分信息因其一旦泄露或被非法使用，可能容易导致你的人格尊严受到侵害或人身、财产安全受到危害，属于敏感个人信息，例如手机号码、登录凭证、身份证件信息、支付交易信息、与账号安全相关的信息等。
        </p>
        <p>
          我们仅会在具有特定目的和<b>充分必要性的前提下处理敏感个人信息，并采取严格保护措施</b>。若你拒绝提供相关敏感个人信息，可能导致对应功能无法实现，但通常不影响其他功能的正常使用。
        </p>

        <p class="title">1.11 征得授权同意的例外</p>
        <p>根据相关法律法规，在以下情形中，我们处理你的个人信息<b>无需事先征得你的授权同意</b>：</p>
        <p class="compact flex"><span>1. </span><span>为订立、履行你作为一方当事人的合同所必需；</span></p>
        <p class="compact flex"><span>2. </span><span>为履行法定义务所必需；</span></p>
        <p class="compact flex"><span>3. </span><span>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></p>
        <p class="compact flex"><span>4. </span><span>为公共利益实施新闻报道、舆论监督等行为，在合理范围内处理个人信息；</span></p>
        <p class="compact flex"><span>5. </span><span>依照法律规定在合理范围内处理你自行公开或者其他已经合法公开的个人信息；</span></p>
        <p class="compact flex"><span>6. </span><span>法律法规规定的其他情形。</span></p>

        <!-- 第二章 -->
        <p class="title">2. 我们如何使用 Cookie 和同类技术</p>

        <p class="title">2.1 保障产品与服务的安全、高效运转</p>
        <p>
          Cookie 和设备信息标识等同类技术是互联网中普遍使用的技术。当你使用元创岛小程序及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个 Cookie 或匿名标识符，以收集、标识和存储你访问、使用本产品时的信息。
        </p>
        <p>
          我们承诺，不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。
        </p>

        <p class="title">2.2 帮助你获得更轻松的访问体验</p>
        <p>
          使用此类技术可以帮助你省去重复填写个人信息、输入搜索内容或重复登录的步骤和流程，例如记录登录状态、偏好设置、历史操作或必要的会话信息。
        </p>

        <p class="title">2.3 Cookie 的清除</p>
        <p>
          你可以通过浏览器、小程序或设备设置拒绝或管理 Cookie 及同类技术。具体关闭方式取决于你选择的浏览器、设备系统或小程序平台。请注意，如果停用 Cookie 或同类技术，你有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。
        </p>

        <!-- 第三章 -->
        <p class="title">3. 数据使用过程中涉及的合作方、转移、公开个人信息</p>
        <p class="compact flex"><span>3.1</span><span>我们不会向第三方出售你的个人信息。</span></p>
        <p class="compact flex"><span>3.2</span><span>我们可能在以下情形下共享你的个人信息：</span></p>
        <p class="compact flex"><span></span><span>（1）在获得你单独同意或授权的情况下；</span></p>
        <p class="compact flex"><span></span><span>（2）为实现本服务核心功能所必需，与第三方登录服务、第三方支付服务、号码认证服务、消息通知服务商、云服务提供方、技术支持合作方、广告归因与统计分析服务商等共享必要信息；</span></p>
        <p class="compact flex"><span></span><span>（3）为履行法定义务、配合行政机关、司法机关或其他有权机关依法提出的要求；</span></p>
        <p class="compact flex"><span></span><span>（4）在发生合并、分立、收购、资产转让、破产清算或其他类似交易时，如涉及个人信息转移，我们将依法要求承接方继续受本隐私政策约束，或重新征求你的授权同意；</span></p>
        <p class="compact flex"><span></span><span>（5）为保护你、其他用户、平台或第三方的生命财产安全及其他重大合法权益所必需。</span></p>
        <p>3.3 我们会对共享行为进行必要评估，并要求合作方按照法律法规、合同约定和我们的要求处理个人信息。</p>
        <p>3.4 除法律法规另有规定或取得你的单独同意外，我们不会公开披露你的个人信息。</p>
        <p>
          3.5 第三方服务与 SDK<br />
          元创岛可能集成或接入第三方服务与 SDK，包括但不限于第三方登录、第三方支付、号码认证、地图服务、崩溃分析、统计分析、广告归因、分享服务、云服务等。相关第三方可能因实现功能所必需而处理部分个人信息或设备信息。具体第三方名称、使用目的、处理方式、信息类型、调用权限及隐私政策链接，以<a href="#/sdkList" target="_blank">《第三方信息共享清单》《第三方 SDK 收集个人信息列表》</a>及产品内实际公示为准。
        </p>
        <p>
          3.6 跨境传输<br />
          原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。目前产品不涉及个人信息跨境传输。如因业务发展需要，确需进行个人信息跨境传输或由境外实体访问你的个人信息，我们将依法履行相应义务，并通过隐私政策、单独告知或其他适当方式向你说明相关情况。
        </p>

        <!-- 第四章 -->
        <p class="title">4. 我们如何存储个人信息</p>

        <p class="title">4.1 存储地点</p>
        <p>
          我们依照法律法规的规定，将在<b>境内运营过程</b>中收集和产生的你的个人信息存储于<b>中华人民共和国境内</b>。目前，我们不会将上述信息传输至境外。如果后续确需向境外传输，我们会严格遵守中国的相关法律、监管政策，并依法履行告知、评估、认证、标准合同或征求同意等义务。
        </p>

        <p class="title">4.2 存储期限</p>
        <p>
          我们会在实现本隐私政策所述目的所必需的最短期限内保存你的个人信息，法律法规另有规定的除外。
        </p>
        <p>
          例如，当你使用手机号码注册登录时，我们需要持续保留你的手机号码，以便向你提供正常服务、应对你可能的查询和客诉并保障你的账号和系统安全。
        </p>
        <p>如果你注销账号、主动删除个人信息或超出必要保存期限后，我们将对你的<b>个人信息进行删除或匿名化处理</b>，但以下情况<b>除外</b>：</p>
        <p class="compact flex"><span>1. </span><span>遵从法律法规有关信息留存的要求；</span></p>
        <p class="compact flex"><span>2. </span><span>出于财务、审计、争议解决、交易安全、售后处理等目的需要合理延长期限；</span></p>
        <p class="compact flex"><span>3. </span><span>删除个人信息从技术上难以立即实现的，我们将停止除存储和采取必要安全保护措施之外的处理。</span></p>

        <p class="title">4.3 保存期限届满后的处理</p>
        <p>
          保存期限届满后，我们将按照法律法规要求<b>删除你的个人信息，或对其进行匿名化处理</b>。因备份、容灾、安全审计或系统机制原因无法立即删除的，我们会在合理期限内完成删除或匿名化，并限制相关信息的进一步处理。
        </p>

        <!-- 第五章 -->
        <p class="title">5. 我们如何保护个人信息的安全</p>
        <p class="compact flex">
          <span>5.1</span>
          <span>我们非常重视你个人信息的安全，将努力采取合理的安全措施，包括技术方面和管理方面的措施，保护你的个人信息，防止你提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</span>
        </p>
        <p class="compact flex">
          <span>5.2</span>
          <span>我们可能采取的安全措施包括访问控制、权限隔离、身份认证、传输加密、日志审计、备份恢复、安全监测、员工培训、内部审批和最小必要授权等。</span>
        </p>
        <p class="compact flex">
          <span>5.3</span>
          <span>我们会建立相应的内部管理制度，对接触个人信息的工作人员采取最小授权原则，并要求其承担保密义务。只有因岗位职责需要并经过授权的人员，才可以访问相应范围内的个人信息。</span>
        </p>
        <p class="compact flex">
          <span>5.4</span>
          <span>尽管已经采取合理有效措施，并遵守相关法律规定要求的标准，但请你理解，由于技术限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。我们将尽力确保你提供给我们的个人信息安全性。</span>
        </p>
        <p class="compact flex">
          <span>5.5</span>
          <span>我们强烈建议你采取积极措施保护个人信息安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码、验证码及相关个人信息透露给他人。</span>
        </p>
        <p class="compact flex">
          <span>5.6</span>
          <span>我们会制定应急处理预案，并在发生个人信息安全事件时立即启动应急预案，努力阻止安全事件的影响和后果扩大。一旦发生个人信息安全事件，我们将按照法律法规要求，及时向你告知安全事件的基本情况和可能影响、我们已经采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施等。我们将以推送通知、邮件、信函、短信、弹窗、公告等合理方式告知你；难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报个人信息安全事件的处置情况。</span>
        </p>

        <!-- 第六章 -->
        <p class="title">6. 行使你的个人信息权利</p>

        <p class="title">6.1 访问、更正、补充个人信息</p>
        <p>
          你有权访问、更正、补充你的个人信息。你可以通过元创岛产品功能页面或联系我们行使相关权利。
        </p>
        <p>
          例如，你可以通过"我的""账号设置""作品管理""消费记录"等页面访问你的账号信息、作品信息、订单信息等。不同端的具体入口可能有所不同，请以实际产品页面展示为准。
        </p>

        <p class="title">6.2 删除个人信息</p>
        <p>
          你有权删除你的个人信息，但法律法规另有规定，或删除后将影响我们履行法定义务、保障交易安全、处理纠纷、完成售后服务或维持服务所必需的除外。
        </p>
        <p>
          你可以通过产品内功能删除你的作品、图片、音频、视频、文档或其他内容。对于无法自行删除的信息，你可以通过本隐私政策载明的联系方式联系我们。
        </p>

        <p class="title">6.3 系统权限设置</p>
        <p>
          你可以在你的设备系统设置中操作关闭或开启相册、媒体、存储、通知、定位、电话状态、悬浮窗等权限，改变授权范围或撤回你的授权。撤回授权后，我们将不再收集与这些权限相关的信息，但不会影响我们此前基于你的授权而开展的个人信息处理活动。
        </p>

        <p class="title">6.4 注销账号</p>
        <p>
          你有权注销你的元创岛账号。你可以通过产品内账号注销入口、联系客服或发送邮件等方式发起注销申请。具体路径以产品实际页面展示为准。
        </p>
        <p>
          在你注销账号前，我们将验证你的个人身份、安全状态、设备信息及账号状态。你知悉并理解，注销账号是不可逆的行为。当你注销账号后，我们将停止为你提供元创岛产品及服务，并删除有关你账号的个人信息或对相关信息进行匿名化处理；因法律法规规定、交易安全、财务审计、争议处理、税务合规或其他法定义务需要留存个人信息的，我们将依法单独存储，并不会将该等信息用于日常业务活动。
        </p>
        <p>
          我们将在收到你的注销申请并完成身份验证后 15 个工作日内完成处理。若因法律法规要求、账号安全核验、未结清交易、争议处理或技术原因暂无法完成注销，我们将向你说明原因。
        </p>
        <p>
          若你认为我们未在承诺期限内处理你的注销请求，或对注销处理结果有异议，你可以通过本隐私政策载明的联系方式进行申诉，我们将在验证你的身份后 15 个工作日内回复。
        </p>

        <p class="title">6.5 撤回授权同意</p>
        <p>
          你有权撤回你已授予的授权同意。撤回授权后，我们将不再继续处理相应个人信息，但不影响撤回前基于你授权已进行的个人信息处理活动的合法性。
        </p>

        <p class="title">6.6 获取个人信息副本</p>
        <p>
          如你希望获取你的个人信息副本，可以通过本隐私政策载明的联系方式联系我们。在符合法律法规要求且技术可行的前提下，我们会向你提供个人信息副本，或按照你的要求将你的个人信息副本传输给你指定的第三方。
        </p>

        <p class="title">6.7 响应你的请求</p>
        <p>
          如你希望行使查阅、复制、转移、更正、补充、删除、注销、撤回授权或其他个人信息权利，可通过本隐私政策载明的联系方式联系我们。为保障你的账号和信息安全，我们可能会要求你进行身份验证。我们将在法律法规规定期限内答复和处理，通常将在验证你的用户身份后的 15 个工作日内回复。
        </p>
        <p>
          对于你合理的请求，我们原则上不收取费用。但对于多次重复、超出合理限度的请求，我们可能视情况收取一定成本费用。
        </p>

        <p class="title">6.8 意见反馈和投诉举报</p>
        <p>
          如果你或其他有权主体对个人信息权利的行使有任何主张、要求或疑问，或者你认为你的个人信息权利可能受到侵害，或发现侵害个人信息权利的线索，你可以通过本隐私政策载明的联系方式与我们联系。我们将尽快审核所涉问题，并在验证你的用户身份后的 15 个工作日内回复。
        </p>

        <!-- 第七章 -->
        <p class="title">7. 未成年人条款</p>
        <p class="compact flex">
          <span>7.1</span>
          <span>元创岛主要面向 18 周岁以上的成年人。我们要求注册用户应为具备完全民事行为能力的自然人。</span>
        </p>
        <p class="compact flex">
          <span>7.2</span>
          <span>元创岛产品及服务不面向 14 周岁以下儿童提供注册服务，也不会主动收集儿童个人信息。</span>
        </p>
        <p class="compact flex">
          <span>7.3</span>
          <span>如你为未成年人，应在监护人指导下阅读并理解本隐私政策，并在取得监护人同意后使用本服务。</span>
        </p>
        <p class="compact flex">
          <span>7.4</span>
          <span>如我们发现或有合理理由怀疑未成年人在未取得监护人同意的情况下向我们提供个人信息，我们将根据法律法规要求采取删除、停止处理、限制功能或其他必要措施。</span>
        </p>

        <!-- 第八章 -->
        <p class="title">8. 隐私政策的修订和通知</p>
        <p class="compact flex">
          <span>8.1</span>
          <span>我们可能根据法律法规变化、业务调整、产品升级、个人信息处理方式变化、第三方 SDK 或合作方变化等原因对本隐私政策进行修改。</span>
        </p>
        <p class="compact flex">
          <span>8.2</span>
          <span>修改后的隐私政策将在应用内、网站页面、弹窗、公告或其他适当方式公布。涉及重大变化的，我们会以更显著方式提示你。</span>
        </p>
        <p class="compact flex">
          <span>8.3</span>
          <span>本隐私政策所指重大变化包括但不限于：产品服务模式发生重大变化；个人信息处理目的、方式、类型发生重大变化；个人信息共享、转让或公开披露的主要对象发生变化；你参与个人信息处理方面的权利及行使方式发生重大变化；我们的联系方式或投诉渠道发生变化；法律法规规定的其他情形。</span>
        </p>
        <p class="compact flex">
          <span>8.4</span>
          <span>如你在隐私政策更新后继续使用元创岛及相关服务，即表示你已阅读并理解更新后的隐私政策。若相关法律法规要求取得你的同意，我们会依法另行征求你的同意。如你不同意更新内容，你应停止使用元创岛及相关服务。</span>
        </p>

        <!-- 第九章 -->
        <p class="title">9. 联系我们</p>
        <p>如你对本隐私政策有任何疑问、意见、建议、投诉举报，或希望行使你的个人信息权利，可通过以下方式联系我们：</p>
        <p class="compact flex">联系邮箱：<span><a href="mailto:yuanchuangdao@mobvoi.com">yuanchuangdao@mobvoi.com</a></span></p>
        <p class="compact flex">客服电话：<span>{{telPhone}}</span></p>
        <p class="compact flex">公司名称：<span>上海墨百意信息科技有限公司</span></p>
        <p>
          一般情况下，我们将在验证你的用户身份后的 15 个工作日内回复。
        </p>
        <p>
          如果你认为我们的个人信息处理行为损害了你的合法权益，你也可以向网信、工信、公安、市场监管等监管部门进行投诉或举报。
        </p>

        <!-- 第十章 -->
        <p class="title">10. 相关术语</p>
        <p class="compact flex">
          <span>10.1</span>
          <span>"个人信息"：是指以电子或者其他方式记录的，与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</span>
        </p>
        <p class="compact flex">
          <span>10.2</span>
          <span>"敏感个人信息"：是指一旦泄露或者非法使用，容易导致自然人人格尊严受到侵害，或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</span>
        </p>
        <p class="compact flex">
          <span>10.3</span>
          <span>"匿名化"：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</span>
        </p>
        <p class="compact flex">
          <span>10.4</span>
          <span>"去标识化"：是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</span>
        </p>
        <p class="compact flex">
          <span>10.5</span>
          <span>"关联方"：是指上海墨百意信息科技有限公司在中国地区的关联公司，包括但不限于出门问问创新科技有限公司、北京小问智能科技有限公司、上海羽扇智信息科技有限公司、北京羽扇智信息科技有限公司、问问智能信息科技有限公司、武汉问问智能信息科技有限公司、深圳问问智能信息科技有限公司、出门问问信息科技有限公司、出门问问（武汉）信息科技有限公司、出门问问（苏州）信息科技有限公司、深圳小问智能科技有限公司、南京小问智能科技有限公司。</span>
        </p>
        <p class="compact flex">
          <span>10.6</span>
          <span>"关联产品和/或服务"：是指魔音工坊、元创邦、魔撰、奇妙元及其他已上线或即将上线的产品和/或服务。</span>
        </p>
        <p class="compact flex">
          <span>10.7</span>
          <span>"合作伙伴"：是指帮助我们提供元创岛产品及服务的第三方服务提供商，包括登录认证、支付、地图服务、客服、统计分析、广告归因、崩溃分析等服务提供方。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
      isMinip: false,
      telPhone: '130 5119 2686'
    }
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  },
  mounted() {
    this.isMobile = this.checkIsMobile()
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') != -1 || ua.indexOf('miniProgram') != -1) {
      this.isMinip = true
    }
    if (this.isMobile) {
      document.title = '元创岛'
    }
  }
}
</script>

<style lang="less" scoped>
.protocol-container {
  font-size: 16px;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  color: #1f2329 !important;

  .highlight {
    font-weight: 800;
  }

  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    margin: 20px auto;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);

    .title {
      width: 100%;
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
    }

    .update-data {
      padding: 12px 0;
      text-align: center;
    }

    .container {
      margin-top: 20px;

      .title {
        font-size: 16px;
        margin-top: 32px;
        font-weight: 800;
        text-align: left;
      }

      .time {
        text-align: left;
      }

      p {
        margin-bottom: 20px;
        line-height: 1.8;

        .highlight {
          font-weight: 800;
        }

        a {
          color: #5a92f4;
        }

        &.compact {
          margin-bottom: 0px;
        }

        &.flex {
          display: flex;
          > span:nth-child(2) {
            margin-left: 1em;
          }
        }

        .q {
          margin-left: 1em;
        }
      }

      .update-data {
        .time {
          font-weight: 800;
        }

        p {
          font-weight: 800;
        }
      }

      .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 20px 0;

        table {
          width: 100%;
          min-width: 600px;
          border-collapse: collapse;
          font-size: 13px;
          line-height: 1.6;

          th, td {
            border: 1px solid #ddd;
            padding: 10px 12px;
            text-align: left;
            vertical-align: top;
            word-break: break-word;
          }

          th {
            background-color: #f2f2f2;
            font-weight: 800;
            color: #1f2329;
            white-space: nowrap;
          }

          tr:nth-child(even) td {
            background-color: #f9f9f9;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}

@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}

@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}

/* 移动端 H5 适配 */
.mobile:not(.minip) {
  .protocol-container {
    height: auto;
    min-height: 100vh;
  }

  .protocol {
    min-width: auto;
    max-width: none;
    width: calc(100% - 32px) !important;
    box-sizing: border-box;
    border-radius: 0;
    padding: 16px;
    margin: 0 auto;
    box-shadow: none;

    .title {
      font-size: 20px;
      margin: 20px 0 14px;
      line-height: 1.4;
    }

    .update-data {
      padding: 8px 0;
      font-size: 13px;
    }

    .container {
      margin-top: 12px;

      .title {
        font-size: 15px;
        margin-top: 20px;
        font-weight: 800;
      }

      p {
        font-size: 14px;
        line-height: 1.8;
        margin-bottom: 14px;

        &.compact {
          margin-bottom: 4px;
        }

        &.flex {
          display: flex;
          > span:nth-child(2) {
            margin-left: 0.5em;
          }
        }
      }

      .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 12px 0;

        table {
          font-size: 12px;
          min-width: 500px;

          th, td {
            padding: 8px 10px;
          }
        }
      }
    }
  }
}

/* 小程序 webview 适配 */
.mobile.minip {
  .protocol {
    min-width: auto;
    max-width: none;
    margin: 0 auto;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    font-size: 14px;

    .title {
      font-size: 18px;
      margin: 16px 0 10px;
    }

    .update-data {
      font-size: 12px;
    }

    .container {
      font-size: 14px;
      line-height: 1.8;

      .title {
        font-size: 15px;
        margin-top: 16px;
      }

      p {
        margin-bottom: 12px;

        &.flex {
          display: flex;
          > span:nth-child(2) {
            margin-left: 0.5em;
          }
        }

        .q {
          margin-left: 0.5em;
        }
      }

      .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        table {
          font-size: 12px;
          min-width: 400px;

          th, td {
            padding: 6px 8px;
          }
        }
      }
    }
  }
}
</style>
